export function composeMiddleware<T>(middlewares: Array<(model: T) => T>) {
	return (model: T) => {
		return middlewares.reduce((memo, middleware) => middleware(memo), model);
	};
}
